module.exports = __webpack_public_path__ + "static/media/yahoo.a464cdfa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/yahoo.svg
// module id = 3836
// module chunks = 7